const { atom } = require('jotai')

export const isSubmitEnabledAtom = atom(false)
export const isValidatingAtom = atom(false)
export const showUiValidationAtom = atom(false)
export const showModalVerificationAtom = atom(false)
export const showErrorVerificationCardAtom = atom(false)
export const dmAtom = atom({})
export const dmCodeAtom = atom('')
export const emailAtom = atom('')
export const dobAtom = atom('')
export const ssnAtom = atom('')

export const errorsAtom = atom({
  email: '',
  dob: '',
  ssn: ''
})

export const isConfirmButtonEnabledAtom = atom((get) => {
  const email = get(emailAtom)
  const dob = get(dobAtom)
  const ssn = get(ssnAtom)
  const fieldsHaveValues = !!email && (!!dob || !!ssn)

  const isValidating = get(isValidatingAtom)

  const errors = get(errorsAtom)
  const fieldsHaveErrors = Object.values(errors).some((error) => !!error)

  return fieldsHaveValues && !isValidating && !fieldsHaveErrors
})
